import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const UserCircle: React.FC<IconProps> = ({
  color = '#fff',
  size = 32,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <circle
      cx={16}
      cy={16}
      r={14.5}
      stroke={color}
      strokeWidth={3}
      fill="none"
    />
    <path
      d="M7 20.88C9.15302 24.0086 12.3855 26 16.0007 26C19.6145 26 22.8484 24.01 25 20.88C22.5591 18.658 19.3416 17.424 16.0007 17.4286C12.6593 17.4236 9.44123 18.6577 7 20.88Z"
      fill={color}
    />
    <path
      d="M15.7661 14.5714C16.933 14.5714 18.0521 14.1199 18.8773 13.3162C19.7024 12.5124 20.166 11.4224 20.166 10.2857C20.166 9.14907 19.7024 8.05898 18.8773 7.25526C18.0521 6.45153 16.933 6 15.7661 6C14.5991 6 13.48 6.45153 12.6549 7.25526C11.8297 8.05898 11.3662 9.14907 11.3662 10.2857C11.3662 11.4224 11.8297 12.5124 12.6549 13.3162C13.48 14.1199 14.5991 14.5714 15.7661 14.5714Z"
      fill={color}
    />
  </svg>
)
